<div legend="Beadchip View" toggleable="true" class="ui-g-12" style="width:100%!important; padding-top: 0px; padding-left:0px">
  <div class="ui-g-12 legendBorderWithPadding parentDiv">
    <div class="ui-g-12" style="font-weight: bold;" id="processingTableHeader">
      Legend
    </div>
    <div class="ui-g-12 noPadding" >
      <div class="noPadding legendBorder384" class="ui-g-12 flex flex-nowrap">

        <!-- Legend 1 -->
        <div class="ui-g-3 legendContainer">
          <div class="ui-g-12 noPadding ml-3">
            <label><!-- Empty block --></label>
          </div>
          <div *ngIf="sourcePlateList.length==0" class="ui-g-12 noPadding ml-3">
            <div class="ui-g-2 noPadding addingPadding">
              <label><!-- Empty block --></label>
            </div>
            <div class="ui-g-6 smallFont ml-3 mt-1">No Source Plates to show</div>
          </div>
          <div *ngIf="sourcePlateList.length>=1" class="ui-g-12 flex align-items-center noPadding ml-3">
            <div class="ui-g-2 noPadding addingPadding">
            <svg height="35" width="35">
              <circle cx="15" cy="20" r="10" stroke="#FFC90E" stroke-width="5" fill="#FFC90E" />
            </svg>
          </div>
          <div class="ui-g-6 smallFont ml-3 mt-1">{{sourcePlateList[0]!=undefined ? sourcePlateList[0]:''}}</div>
          </div>
        </div>
        
        <!-- Legend 2 -->
        <div class="ui-g-3 legendContainer">
          <div class="ui-g-12 noPadding ml-3">
            <label><!-- Empty block --></label>
          </div>
          <div *ngIf="sourcePlateList.length>=2" class="ui-g-12 flex align-items-center noPadding ml-3">
            <div class="ui-g-2 noPadding addingPadding">
              <svg height="35" width="35">
                <circle cx="15" cy="20" r="10" stroke="#00CE00" stroke-width="3" fill="#00CE00" />
              </svg>
            </div>
            <div class="ui-g-6 smallFont ml-3 mt-1"><span>{{sourcePlateList[1]!=undefined ? sourcePlateList[1]:''}}</span></div>
          </div>
        </div>

        <!-- Legend 3 -->
        <div class="ui-g-3 legendContainer">
          <div class="ui-g-12 noPadding ml-3">
            <label><!-- Empty block --></label>
          </div>
          <div *ngIf="sourcePlateList.length>=3" class="ui-g-12 flex align-items-center noPadding ml-3">
            <div class="ui-g-2 noPadding addingPadding">
              <svg height="35" width="35">
                <circle cx="15" cy="20" r="10" stroke="#EE82EE" stroke-width="3" fill="#EE82EE" />
              </svg>
            </div>
            <div class="ui-g-6 smallFont ml-3 mt-1"><span>{{sourcePlateList[2]!=undefined ? sourcePlateList[2]:''}}</span></div>
          </div>
        </div>

        <!-- Legend 4 -->
        <div class="ui-g-3 legendContainer">
          <div class="ui-g-12 noPadding ml-3">
            <label><!-- Empty block --></label>
          </div>
          <div *ngIf="sourcePlateList.length>=4"  class="ui-g-12 flex align-items-center noPadding ml-3">
            <div class="ui-g-2 noPadding addingPadding">
              <svg height="35" width="35">
                <circle cx="15" cy="20" r="10" stroke="#00FFFF" stroke-width="3" fill="#00FFFF" />
              </svg>
            </div>
            <div class="ui-g-6 smallFont ml-3 mt-1"><span>{{sourcePlateList[3]!=undefined ? sourcePlateList[3]:''}}</span></div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  <div class="ui-g-12" style="padding-left:0px">
    <div class="ui-g-12 noPadding" style="padding-top: 1%; width: 100%" >
      <table data-vertable="ver5" aria-describedby="Detail view" id="scanTable" class="table"
        style="width: 100%;">
        <thead>
          <tr class="row100 head">
            <th scope="col" class="column100 column1" style="padding: 0.75rem 0px 0.75rem 0px!important; width: 20px;"></th>
            <th scope="col" class="column100 column2" style="padding: 0.75rem 0px 0.75rem 0px!important; width: 20px;" *ngFor="let col of columnHeaders384">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders384; let i = index;">
            <td class="column100 column1" style="color: #006b96;font-weight: bold; padding-right:0px!important">{{row}}</td>
            <td (mouseenter)="mouseEnter(i,j)" (mouseleave)="mouseLeave(i,j)" class="column100 column2" *ngFor="let col of columnHeaders384; let j = index" style="padding:0%">
              <ng-container>
                <ng-container>
                  {{getColor(i,j,plateMap)}}
                  <button [tooltipDisabled]="!sampleHoverVisible" pTooltip="{{getToolTip(i,j)}}" tooltipPosition="left" style="border: 1px solid white; background-color: transparent; padding: 0%;"
                    (click)="showSamplePopUp(i, j)">
                    <svg [ngStyle]="getQuadrant(i,j)" height="36" width="80" viewBox="0 0 80 36" style="width: 40px; display: block!important;" class="pleaseCOME">
                      <circle cx="42" cy="18" r="25" attr.stroke="{{circleBorder}}"
                        attr.stroke-width="{{circleStroke}}" attr.fill="{{color}}" />
                    </svg>    
                  </button>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<p-dialog header="Sample Information" [(visible)]="samplePopVisible" [modal]="true" [contentStyle]="{'max-height':'70vh', 'width':'55vh'}" [blockScroll]="true" position="top">
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Source Plate-ID"></button>
    <input pInputText type="text" name="sourcePlateID" [value]="sourcePlateID"  readonly />
  </div>
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
    <input pInputText type="text" name="sampleID" [value]="sampleID" readonly />
  </div>
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Position"></button>
    <input pInputText type="text" name="samplePosition" [value]="samplePosition" readonly />
  </div>
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Original Pos."></button>
    <input pInputText type="text" name="orgPosition" [value]="orgPosition" readonly />
  </div>
  <div class="ui-inputgroup" id="inputClass">
    <button pButton class="theme-button noHover labelButton" type="button" label="Conc."></button>
    <input pInputText type="text" name="sampleConcentration" [value]="sampleConcentration" readonly />
  </div>
  <div class="ui-inputgroup" id="inputClass">
    <button pButton (click)="toggleCommentView()" class="theme-button adjust-width" type="button" [label]="commentView? 'Hide Comment(s)': 'View Comment(s)'"></button>
  </div>

  <div *ngIf="commentView">
    <div  class="ui-g-11 ml-3 rounded border border-secondary commentBubble">
      <div style="text-align:left" class="ui-g-11 pb-0">
        <label><strong> Sample ID : </strong>{{sampleID}}</label>
      </div>
      <div>
        <div *ngFor="let comment of sampleComments">
          <div class="ui-g-12 p-0 commentBubbleSection">
            <div style="text-align:left" class="ui-g-12 commentPUIDDate">
              <label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}}</label>
            </div>
            <div style="text-align:left" class="ui-g-12 commentPUIDDate font-weight-bold">
              <p>{{comment.comment}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="ui-g-12" id="commentTextAreDiv">
      <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
        [(ngModel)]="newComment"></textarea>
    </div>
  </div>

  <p-footer>
    <button pButton (click)="closeSamplePopup()" label="Done"></button>
  </p-footer>
</p-dialog>
